import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-94d6e650"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-right mb10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("編集")

import { useRoute, useRouter } from 'vue-router'
  import { computed, onMounted, ref, watch } from "vue";
  import LearningCourseDetail from "@/components/learning/LearningCourseDetail.vue";
  import { LearningCourseLogic } from "@/logic/learning/LearningCourseLogic";
  import { LearningCategoryLogic } from "@/logic/learning/LearningCategoryLogic";
  import { QuestionCategoryLogic } from "@/logic/question/QuestionCategoryLogic";
  import { QusitionState } from "@/state/QusitionState";
  import { LearningCategory } from '@/types/learning_category'
  import { useChangeCategoryForm } from "@/logic/learning_course/ChangeCategoryFormLogic";
  import { useExceptionMessage } from '@/logic/ExceptionMessageLogic';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const router = useRouter();
  // 暫定でここでリポジトリ呼び出し
  const route = useRoute();
  const {
    learningCourse,
    learningForms,
    learningCourseLoading,
    getLearningCourse,
  } = LearningCourseLogic();
  const { loadQuestionCategories, questionCategoryLoading } = QuestionCategoryLogic();
  const { loadLearningCategories, learningCategoryLoading, learningCategories } = LearningCategoryLogic();
  const projectId = computed(() => Number(route.params.project_id));
    const { changeCategory } = useChangeCategoryForm(Number(route.params.project_id));
  const learningCourseId = computed(() => Number(route.params.learning_course_id));
  onMounted(async (): Promise<void> => {
    getLearningCourse(projectId.value, learningCourseId.value)
    QusitionState.setProjectId(projectId.value);
    loadQuestionCategories();
    loadLearningCategories();
  });

  const categoryName = ref('');
  watch(learningCourse, (learningCourse) => {
    if (learningCourse.category) {
      categoryName.value = learningCourse.category.name;
    }
  });
  const moveCategoryDialogVisible = ref(false)
  const handleMoveCategoryDialogVisible = (visible: boolean) => {
    moveCategoryDialogVisible.value = visible;
  };
  const handleUpdateCategory = (category: LearningCategory) => {
    if (category.id === 0) {
      return;
    }
    try {
      changeCategory(Number(route.params.learning_course_id), category.id);
      categoryName.value = category.name;
      handleMoveCategoryDialogVisible(false)
    } catch (e) {
      useExceptionMessage(e);
    }
  };

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({name: 'ProjectLearningCourseEdit'})))
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _createVNode(LearningCourseDetail, {
          modelValue: _unref(learningCourse),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(learningCourse) ? (learningCourse).value = $event : null)),
          learningCategories: _unref(learningCategories),
          categoryName: categoryName.value,
          learningForms: _unref(learningForms),
          moveCategoryDialogVisible: moveCategoryDialogVisible.value,
          "onUpdate:moveCategoryDialogVisible": handleMoveCategoryDialogVisible,
          "onUpdate:category": handleUpdateCategory
        }, null, 8, ["modelValue", "learningCategories", "categoryName", "learningForms", "moveCategoryDialogVisible"])
      ], 512), [
        [_directive_loading, _unref(learningCourseLoading) || _unref(questionCategoryLoading) || _unref(learningCategoryLoading)]
      ])
    ])
  ]))
}
}

})